import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Signes() {
  const { t } = useTranslation('toiture');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  const signes = [
    { icon: 'ri-windy-line', text: t('signe_1') },
    { icon: 'ri-filter-3-line', text: t('signe_2') },
    { icon: 'ri-drop-line', text: t('signe_3') },
    { icon: 'ri-arrow-down-wide-line', text: t('signe_4') },
    { icon: 'ri-calendar-line', text: t('signe_5') },
  ];

  return (
    <section id="signes" className="bg-soft-gray py-20 md:py-28 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Image */}
          <div className="order-2 lg:order-1 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Damaged%20asphalt%20shingle%20roof%20with%20visible%20wear%2C%20curled%20and%20missing%20shingles%2C%20water%20damage%20and%20staining%2C%20close-up%20macro%20shot%20showing%20granule%20loss%2C%20Quebec%20residential%20house%20roof%20in%20need%20of%20repair%2C%20dramatic%20overcast%20lighting%2C%20professional%20inspection%20photography%20style%2C%20no%20text%20visible&width=800&height=600&seq=toiture-signes1&orientation=landscape"
              alt="Toiture endommagée avec bardeaux fendus et granules perdus à Lévis — inspection par couvreur RBQ"
              className="w-full h-64 md:h-80 object-cover"
              loading="lazy"
              width="800"
              height="600"
            />
          </div>

          {/* Text */}
          <div className="order-1 lg:order-2">
            <h2
              className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl leading-tight mb-8"
              dangerouslySetInnerHTML={{ __html: t('signes_h2') }}
            />
            <div className="space-y-5">
              {signes.map((signe, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-copper/10 shrink-0">
                    <i className={`${signe.icon} text-copper`} />
                  </div>
                  <span className="text-gray-600 text-base pt-2">{signe.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}